import httpService from "./htttp.service";

class AdminService {
  async getUsers() {
    const getUsers = "admin/users";
    return await httpService.get(getUsers);
  }

  async toggleUserEnabled(userId, enabled) {
    const toggleEndpoint = `admin/users/${userId}/enabled`;
    const payload = { enabled };
    return await httpService.put(toggleEndpoint, payload);
  }
}

const adminService = new AdminService();
export default adminService;